
// @mui
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
// components
import Iconify from 'src/components/iconify';
// types
import { CaySam, CaySamNhatKy } from 'src/types/caysam';
import { OptionModel } from 'src/types/api-response';
import TimeLine from '../components/time-line';

// ----------------------------------------------------------------------

type Props = {
  caySamData: CaySam | null;
  caySamNhatKy: CaySamNhatKy[] | null;
  loadingNhatKy: boolean;
  showTimeline: boolean;
  onViewHistory: VoidFunction;
  tinhTrangOptions: OptionModel[];
  onOpenPreview: (url: string | null | undefined) => void;
};

export default function CaySamHistory({
  caySamData,
  caySamNhatKy,
  loadingNhatKy,
  showTimeline,
  onViewHistory,
  tinhTrangOptions,
  onOpenPreview,
}: Props) {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          Lịch sử sinh trưởng
        </Typography>
        <Button
          variant="outlined"
          size="small"
          startIcon={<Iconify icon="solar:history-bold" />}
          onClick={onViewHistory}
          disabled={!caySamData?.caySam_ID || loadingNhatKy}
        >
          {loadingNhatKy ? 'Đang tải...' : 'Xem lịch sử'}
        </Button>
      </Box>

      {!showTimeline && (
        <Box sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
          <Typography variant="body2">
            Nhấn &quot;Xem lịch sử&quot; để hiển thị dữ liệu sinh trưởng
          </Typography>
        </Box>
      )}

      {showTimeline && (!caySamNhatKy || caySamNhatKy.length === 0) && (
        <Box sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
          <Typography variant="body2">Chưa có dữ liệu sinh trưởng</Typography>
        </Box>
      )}

      {showTimeline && caySamNhatKy && caySamNhatKy.length > 0 && (
        <TimeLine
          title=""
          itemsNhatKy={caySamNhatKy.filter((x): x is CaySamNhatKy => !!x)}
          tinhTrangOptions={tinhTrangOptions}
          onImageClick={onOpenPreview}
        />
      )}
    </Box>
  );
}
